import { Banner, DANGER, SUCCESS } from '@primerai/thread';
import { useLogoutBanner } from './useLogoutBanner';

export const LoginFeedback = ({ error }: { error?: Error }) => {
  const { handleCloseBanner, showBanner } = useLogoutBanner();

  if (error) {
    return (
      <Banner intent={DANGER} message={error?.message ?? 'Unknown Error'} />
    );
  }

  if (showBanner) {
    return (
      <Banner
        intent={SUCCESS}
        message="Logged out successfully"
        onClose={handleCloseBanner}
      />
    );
  }

  return null;
};
